import { plural, t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'
import { TextThemeUI } from '@jotta/ui/themeui'

export interface DeletePhotoDialogProps extends RadixModalProps {
  count?: number
  isLoading?: boolean
  onClose: (open: boolean) => void
  onDeletePhoto: () => void
}

export const DeletePhotoDialog: React.FC<DeletePhotoDialogProps> = ({
  count = 1,
  isLoading = false,
  onClose,
  onDeletePhoto,
  ...props
}) => {
  return (
    <RadixModal onClose={onClose} {...props}>
      <RadixDialog
        title={plural(count, {
          one: 'Are you sure you want to delete the selected photo?',
          other: 'Are you sure you want to delete the # selected photos?',
        })}
        onClose={onClose}
        data-testid="DeletePhotoDialog"
        buttons={[
          {
            label: plural(count, {
              one: 'Yes, delete photo',
              other: 'Yes, delete photos',
            }),
            loading: isLoading,
            action: onDeletePhoto,
            type: 'destructive',
            testId: 'confirm',
          },
          {
            action: 'close',
            label: t`Cancel`,
            testId: 'cancel',
            type: 'outline',
          },
        ]}
      >
        <TextThemeUI variant="styles.p" sx={{ mb: 3 }}>
          <Trans>
            Deleted files are removed from all of your synced devices, and all
            your shares and albums. For a period of 30 days you can restore the
            deleted files by selecting "Trash" in the user menu.
          </Trans>
        </TextThemeUI>
      </RadixDialog>
    </RadixModal>
  )
}
